import { useTranslation } from 'react-i18next';

import { Flex, Typography } from 'antd';

import { IProfileItem } from 'entities/User';
import { ProfileItem } from 'entities/User/ui/ProfileItem/ProfileItem';
import { useAppConfigRetrieveQuery } from 'shared/api';

import styles from './PersonalInfo.module.scss';

export const PersonalInfo = () => {
	const { t } = useTranslation();
	const { data: appConfig } = useAppConfigRetrieveQuery();

	const personalInfoArray: Array<IProfileItem> = [
		{ title: t('Никнейм'), key: 'nickname', value: appConfig?.user?.tg_username || '', type: 'input' },
		// { title: t('Телефон'), key: 'phone', value: accountProfile., type: 'input' },
		// {
		// 	title: t('Локация'),
		// 	key: location,
		// 	value: location,
		// 	type: 'select',
		// 	items: metaData?.countryOptions,
		// 	action: (key: string, value: string) => handleActionChange(key, value),
		// },
		// {
		// 	title: t('Начало недели'),
		// 	key: 'week_start',
		// 	value: weekStart,
		// 	type: 'select',
		// 	items: [
		// 		{ label: 'C понедельника', value: 'monday' },
		// 		{ label: 'C воскресенья', value: 'sunday' },
		// 	],
		// 	action: (key: string, value: string) => handleActionChange(key, value),
		// },
		// {
		// 	title: t('Вид календаря в планере'),
		// 	key: 'calendar_type',
		// 	value: calendarType,
		// 	type: 'select',
		// 	items: [
		// 		{ label: 'Все календари', value: 'all_calendars' },
		// 		{ label: 'Григорианский', value: 'gregory' },
		// 	],
		// 	action: (key: string, value: string) => handleActionChange(key, value),
		// },
	];

	return (
		<Flex vertical gap={8} className={styles.info}>
			<Typography.Title level={5} style={{ margin: 0 }}>
				{t('Обо мне')}
			</Typography.Title>
			<dl className={styles.body}>
				{personalInfoArray.map((item) => (
					<ProfileItem item={item} key={item.key} />
				))}
			</dl>
		</Flex>
	);
};
